import { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Title,
  createStyles,
  Text,
  Grid,
  Loader,
  Modal,
  Center,
  Input,
  Button,
  Card,
} from "@mantine/core";
import { useMedplum } from "@medplum/react";
import medical from "../../assets/img/medical.svg";
import health from "../../assets/img/health.svg";
import postDischagre from "../../assets/img/postDischarge.svg";
import remote from "../../assets/img/remote.svg";
import pre from "../../assets/img/pre.svg";
import phone from "../../assets/img/phone.svg";
import teleHealth from "../../assets/img/teleHealth.svg";
import { useNavigate } from "react-router-dom";
import { extractQuestionnare, mapQuestionnaireToCardDetails } from "./Service";
import { IconMessage, IconPhone } from "@tabler/icons-react";
import { PatientSelect } from "../../components/PatientSelect";
import { COLORS } from "../AIRecipes/costansts";
import { startEducationCall, startEducationChat } from "./educationService";
import { showNotification } from "@mantine/notifications";
// import { MCPClient } from "./mcp.service";

const useStyles = createStyles(() => ({
  paper: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "40px",
  },
  mainBox: {
    display: "flex",
    flexDirection: "column",
    padding: "24px",
  },
  boxModal1: { display: "flex", flexDirection: "column", gap: "16px" },
  boxModal2: {
    padding: "12px",
    gap: "20px",
    display: "flex",
    flexDirection: "column",
  },
  boxModal4: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    marginTop: "16px",
    justifyContent: "flex-end",
  },
  boxModal5: { display: "flex", flexDirection: "row", gap: "8px" },
  title: {
    marginTop: "15px",
    fontWeight: 600,
    fontSize: "22px",
    lineHeight: "30px",
    color: "#262930",
    paddingTop: "12px",
    paddingBottom: "17px",
  },
  box1: {
    padding: "12px",
    border: "1px solid #EDEDED",
    borderRadius: "8px",
    gap: "16px",
    display: "flex",
    flexDirection: "row",
    minHeight: "118px",
    cursor: "pointer",
  },
  loaderBox: {
    display: "flex",
    justifyContent: "center",
  },
  box3: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },
  recentBox: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid #EDEDED",
    borderRadius: "6px",
    gap: "12px",
    padding: "12px",
  },
  boxSelect: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    // width: "50%",
  },
  boxButton: {
    display: "flex",
    flexDirection: "row",
    gap: "6px",
  },
  boxSelect1: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    gap: "6px",
  },
  heading: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "21px",
    display: "flex",
    alignItems: "center",
  },
  card: {
    padding: '10px',
    borderRadius: '8px',
    backgroundColor: 'transparent',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  text: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "21px",
    color: "#474E5B",
  },
  row: { display: "flex", flexDirection: "row" },
}));

export const VoiceAi = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const navigate = useNavigate();
  const [mappedIds, setMappedIds] = useState<MappedIdsType>({});
  const [resource, setResource] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPatDropdown, setIsPatDropdown] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState<any>();
  const [tab, setTab] = useState<string>("Chat");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [chatContext, setChatContext] = useState<'education' | 'medical-assistant'>('education');
  const [recentQnrRes, setRecentQnrRes] = useState<any>([]);

  const cardDetails = [
    {
      heading: "Medication Adherence Support",
      subheading: "Reminders and adherence checks for medication.",
      backgroundColor: "#F1F9FF",
      image: medical,
    },
    {
      heading: "Telehealth Visit Preparation",
      subheading: "Collecting information before telehealth visits.",
      backgroundColor: "#F9FCFF",
      image: teleHealth,
    },
    {
      heading: "Annual Health Check-Up Reminders",
      subheading: "Reminders for annual check-ups and screenings.",
      backgroundColor: "#F7FFF4",
      image: health,
    },
    {
      heading: "Pre-Appointment Insurance Verification",
      subheading:
        "Automated calls to verify insurance information before appointments.",
      backgroundColor: "#FBF8FF",
      image: pre,
    },
    {
      heading: "Remote Patient Monitoring (RPM) Check-Ins",
      subheading: "Regular check-ins to collect data from RPM devices.",
      backgroundColor: "#FFF4F8",
      image: remote,
    },
    {
      heading: "Automated Confirmation Calls",
      subheading:
        "The system automatically calls patients to confirm upcoming appointments.",
      backgroundColor: "#FFF9EC",
      image: phone,
    },
    {
      heading: "Post-Discharge Follow-Up",
      subheading: "Follow-up calls to check on patients after discharge.",
      backgroundColor: "#FFF3F3",
      image: postDischagre,
    },
    {
      heading: "Hospital Discharge Planning",
      subheading: "Assisting with post-discharge care instructions.",
      backgroundColor: "#FBF3FF",
      image: pre,
    },
  ];

  useEffect(() => {
    questionnaireResponse().then(() => {
      setLoading(false);

    });
  }, []);
  type MappedIdsType = {
    [key: string]: string[];
  };

  const questionnaireResponse = async () => {
    const res = await extractQuestionnare(medplum, 20, 1);
    setResource(res);
    const filteredQnr = res.filter((e) => e?.code)
    const mapped = mapQuestionnaireToCardDetails(filteredQnr, cardDetails, false);
    const result = mapped.reduce((acc: any, curr: any) => {
      // Ensure acc is initialized as an empty object on the first iteration
      if (!acc) {
        acc = {};
      }

      // Initialize the property if it doesn't exist
      if (!acc[curr.heading]) {
        acc[curr.heading] = [];
      }

      // Push the current ID into the array for the current heading
      acc[curr.heading].push(curr.id);

      // Update the state (assuming setMappedIds is a state setter from useState)
      setMappedIds(acc);

      return acc;
    }, {});
  };

  const handleCardClick = (heading: string) => {
    debugger
    navigate("questionnare-list", {
      state: { ids: mappedIds[heading], name: heading },
    });
  };

  const onPatientSelect = async (patientData: any) => {
    //Will be filtering out Qres with uuid Questionaires
    //Fix this with a better approach later on
    const uuidRegex = /\b[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\b/i;
    const recentQnrRes = await medplum.searchResources(
      "QuestionnaireResponse",
      `_sort=-_lastUpdated&_count=20&source=Patient/${patientData?.id}`
    )
    if (recentQnrRes?.length) {
      const formattedRecentQnrRes = recentQnrRes
        .filter((qres) => qres?.questionnaire && !uuidRegex.test(qres?.questionnaire))
        .map((res: any) => {
          const date = new Date(res?.meta?.lastUpdated);
          return {
            id: res.id,
            date: date.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' }),
            text: res?.questionnaire ?? "Patient Companion Chat",

          }
        })
      //only set 5 most recent qnr res
      setRecentQnrRes(formattedRecentQnrRes.slice(0, 5));
    }
    setSelectedPatient(patientData);
    setPhoneNumber(
      patientData?.telecom?.find((tel: any) => tel?.system === "phone")
        ?.value ?? ""
    );
  };
  const handleStartChat = async (recentQnrRes?: string) => {
    setIsLoading(true);
    let qnrResId = recentQnrRes;
    if (!qnrResId) {
      const chatRes = await startEducationChat(medplum, selectedPatient?.id);
      if (!chatRes?.qnrRes) return
      qnrResId = chatRes?.qnrRes?.id
    }
    setShowModal(false);
    navigate(`questionnare-list/details/${selectedPatient?.id}`, {
      state: { qtrResID: qnrResId, chatContext: chatContext },
    });
  };

  const handleStartCall = async () => {
    setIsLoading(true);
    const callRes = await startEducationCall(medplum, selectedPatient?.id, phoneNumber);
    if (callRes?.socket?.commToken)
      showNotification({
        color: "green",
        message: `Call created Successfully with sid: ${callRes.sid} `,
      });
    setShowModal(false);
    // navigate(`questionnare-list/details/${selectedPatient?.id}`, {
    //   state: { qtrResID: chatRes.qnrRes.id },
    // });
  };

  return (
    <Paper className={classes.paper}>
      {showModal && (
        <Modal
          opened={showModal}
          onClose={() => {
            setShowModal(false);
          }}
          withCloseButton={false}
          size={"xl"}
        >
          <Box className={classes.mainBox}>
            {isLoading ? (
              <Center mih="400px">
                <Loader variant="dots" />
              </Center>
            ) : (
              <Box className={classes.boxModal1}>
                <Title className={"a"}>
                  {chatContext === "education" && "Patient Education"}
                  {chatContext === "medical-assistant" && "Qconnect Patient Companion"}
                </Title>
                <Box className={classes.boxButton}>
                  <Button
                    onClick={() => setTab("Chat")}
                    variant={tab === "Chat" ? "filled" : "outline"}
                  >
                    <IconMessage
                      color={tab === "Chat" ? "white" : COLORS.borderBlue}
                      size={18}
                      style={{ marginRight: "6px" }}
                    />{" "}
                    AI Chat
                  </Button>
                  {chatContext === "education" && <Button
                    onClick={() => setTab("Voice")}
                    variant={tab === "Voice" ? "filled" : "outline"}
                  >
                    <IconPhone
                      color={tab === "Voice" ? "white" : COLORS.borderBlue}
                      size={18}
                      style={{ marginRight: "6px" }}
                    />{" "}
                    AI Voice
                  </Button>}
                </Box>
                <Box
                  className={classes.boxSelect}
                  mb={isPatDropdown ? 250 : "auto"}
                >
                  <Text className={classes.text}>Select Patient</Text>
                  <PatientSelect
                    hanldeSelect={onPatientSelect}
                    onSelectOpen={(opened: boolean) => setIsPatDropdown(opened)}
                  />
                </Box>
                {chatContext === "medical-assistant" && (
                  <>
                    <Text className={classes.text}>Recent Chats</Text>
                    <Box className={classes.recentBox}>
                      {recentQnrRes?.map((qnrRes: any) => (
                        <Card
                          key={qnrRes.id}
                          className={classes.card}
                          onClick={() => {
                            handleStartChat(qnrRes.id);
                          }}
                        >
                          <Text className={classes.text}>{qnrRes?.date} - {qnrRes?.text}</Text>
                        </Card>
                      ))}
                    </Box>
                  </>
                )}

                {tab === "Voice" && (
                  <Box className={classes.boxSelect}>
                    <Text className={classes.text}>Phone Number</Text>
                    <Input
                      radius="md"
                      size="md"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder={"Enter Phone Number"}
                      rightSection={
                        <IconPhone
                          size="1rem"
                          style={{ display: "block", opacity: 0.5 }}
                        />
                      }
                    />
                  </Box>
                )}
                <Box className={classes.boxModal4}>
                  <Box className={classes.boxModal5}>
                    <Button
                      onClick={() => {
                        setShowModal(false);
                      }}
                      variant="outline"
                      sx={{ color: "#262930" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={tab === "Chat" ? () => handleStartChat() : handleStartCall}
                    >
                      {"Start " + tab}{" "}
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Modal>
      )}
      <Title className={classes.title}>QConnect AI</Title>
      {loading && (
        <Box className={classes.loaderBox}>
          <Loader mt={"20%"} />
        </Box>
      )}
      <Box mt={20}>
        <Grid>
          {!loading && (
            <Grid.Col span={12}>
              <Box
                onClick={() => {
                  setChatContext('medical-assistant');
                  setShowModal(true);
                }}
                className={classes.box1}
                style={{ backgroundColor: "#FBF8FF" }}
              >
                <Box>
                  <img src={pre} alt={"Patient Education"} />
                </Box>
                <Box className={classes.box3}>
                  <Text mt={4} className={classes.heading}>
                    {"Qconnect Patient Companion"}
                  </Text>

                  <Text lineClamp={2} className={classes.text}>
                    {"Empowered by Qconnect’s FHIR-enabled Agentic Platform"}
                  </Text>
                </Box>
              </Box>
            </Grid.Col>
          )}
        </Grid>
        <Grid>
          {!loading &&
            cardDetails.map((card, index) => (
              <Grid.Col span={4} key={index}>
                <Box
                  onClick={() => handleCardClick(card.heading)}
                  className={classes.box1}
                  style={{ backgroundColor: card.backgroundColor }}
                >
                  <Box>
                    <img src={card.image} alt={card?.heading} />
                  </Box>
                  <Box className={classes.box3}>
                    <Text mt={4} className={classes.heading}>
                      {card.heading}
                    </Text>

                    <Text lineClamp={2} className={classes.text}>
                      {card.subheading}
                    </Text>
                  </Box>
                </Box>
              </Grid.Col>
            ))}
          {!loading && (
            <Grid.Col span={4}>
              <Box
                onClick={() => {
                  setShowModal(true)
                  setChatContext('education')
                }}
                className={classes.box1}
                style={{ backgroundColor: "#FBF8FF" }}
              >
                <Box>
                  <img src={pre} alt={"Patient Education"} />
                </Box>
                <Box className={classes.box3}>
                  <Text mt={4} className={classes.heading}>
                    {"Patient Education"}
                  </Text>

                  <Text lineClamp={2} className={classes.text}>
                    {"Automated system for answering questions from patients"}
                  </Text>
                </Box>
              </Box>
            </Grid.Col>
          )}
        </Grid>
      </Box>
    </Paper>
  );
};
